import { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import i18n from "../i18n"; // make sure the path is correct based on your project structure
import { TypeAnimation } from 'react-type-animation';



import "./css/HomePage.css";

export default function HomePage() {

  const services = [
    {
        id: 1,
        title: "NFC Cards for Google Reviews",
        icon: "📇",
        link: "/nfc-reviews",
    },
    {
        id: 2,
        title: "Discord Bots & Automation",
        icon: "🤖",
        link: "https://discord.gg/DYbX4zJg38",
    },
    {
        id: 3,
        title: "Digital Menus (QR Code / NFC)",
        icon: "📋",
        link: "/menu-demo",
    },
    {
        id: 4,
        title: "REST API's & Web Services",
        icon: "🔗",
    },
    {
        id: 5,
        title: "Website Development",
        icon: "🌐",
    },
    {
        id: 6,
        title: "Web Scraping",
        icon: "🕷️",
    },
    {
        id: 7,
        title: "Software Development",
        icon: "🖥️",
    },
];



  const [darkMode, setDarkMode] = useState(false);
  const vantaRef = useRef(null);
  const { t } = useTranslation();

  const toggleTheme = () => setDarkMode((prev) => !prev);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };



  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await fetch('https://website-backend-production-2163.up.railway.app/api/projects');
        const data = await res.json();
        setProjects(data.reverse());
      } catch (err) {
        console.error('Failed to fetch projects:', err);
      }
    };

    fetchProjects();
  }, []);


  return (
    <div
      ref={vantaRef}
      className={`homepage ${darkMode ? "light-mode" : "dark-mode"}`}
    >
      
      {/* Language Switcher */}
      <div className="lang-switcher">
       <button onClick={() => changeLanguage("pt")} style={{ background: "none", border: "none", padding: "5px" }}>
        <img
          src="https://raw.githubusercontent.com/hampusborgos/country-flags/main/svg/br.svg"
          alt="Português"
          width="32"
          style={{ borderRadius: "4px" }}
        />
      </button>

      <button onClick={() => changeLanguage("en")} style={{ background: "none", border: "none", padding: "5px" }}>
        <img
          src="https://raw.githubusercontent.com/hampusborgos/country-flags/main/svg/us.svg"
          alt="English"
          width="32"
          style={{ borderRadius: "4px" }}
        />
      </button>

      </div>

      {/* Theme Toggle */}
      <button className="theme-toggle" onClick={toggleTheme}>
        {darkMode ? "🌙" : "☀️"}
      </button>

      {/* Hero Section */}
      <section className="hero">
        <motion.img
          src="/White3DKeycapFNNoBackground.png"
          alt="fn key"
          className="fn-image"
          whileHover={{ scale: 1.1 }}
        />
        <motion.h1
          className="title"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
        >
          {t("title")}
        </motion.h1>
        <TypeAnimation
          sequence={[
            'Building modern websites 💻',
            2000,
            'Developing fun games 🎮',
            2000,
            'Offering IT consulting 🤝',
            2000,
            'Designing ideas into products 🚀',
            2000,
          ]}
          wrapper="span"
          speed={50}
          style={{ fontSize: '1.5em', display: 'inline-block', color: darkMode ? '#fff' : '#000', backgroundColor: "#eee", borderRadius: "15px"
            , padding: "10px"
          }}
          repeat={Infinity}
        />
        <p
          className="subtitle"
          dangerouslySetInnerHTML={{ __html: t("subtitle") }}
        ></p>
        <div className="button-group">
          <a href="/hub" className="btn primary">
            Hub Projects
          </a>
          <a href="#contactHome" className="btn outline">
            Contact
          </a>
        </div>
      </section>

      {/* About Section */}
      <section id="aboutSec" className="section">
        <div className="about-card">
          <h2>{t("aboutTitle")}</h2>
          <p>{t("aboutText")}</p>
        </div>
      </section>

      {/* Serviços */}
      <section id="servicos" className="section light">
        <h2>
          👉<a className="redirectButton" href="/services">{t("services")}</a>
        </h2>
       <div className="services-grid">
                {services.map((service) => {
                    const CardTag = service.link ? "a" : "div";
                    const cardProps = service.link
                        ? { href: service.link, className: "service-card service-card-link" }
                        : { className: "service-card" };

                    return (
                        <CardTag key={service.id} {...cardProps}>
                            <div className="service-icon">{service.icon}</div>
                            <h3 className="service-name">{service.title}</h3>
                        </CardTag>
                    );
                })}
            </div>
      </section>


      {/*Portifolio*/}
      <section id="portfolio" className="section">
      <h2>
        👉<a className="redirectButton" href="/projects">Portfólio</a>
      </h2>
                <div className="projects-grid">
                {projects.map((project) => (
                    <div className="project-card2" key={project._id}>
                    <div className="project-img-wrapper">
                        <img
                            src={project.imageUrl || "Designer3DFNKeycap.png"}
                            alt={project.title}
                            className="project-image-port"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "Designer3DFNKeycap.png";
                            }}
                        />
                    </div>
                    <h2 style={{color: darkMode ? "#333" : "#eee"}} className="project-title">{project.title || 'No title found'}</h2>
                    <div className="project-body">
                        <div className="project-links">
                            <a
                                href={project.github}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="project-button"
                            >
                                View on GitHub
                            </a>
                        </div>
                    </div>
                </div>

                ))}
            </div>
      
    </section>



      {/* Contato */}
      <section
        id="contactHome"
        className={darkMode ? "section light" : "section dark"}
      >
        <h2><a className="redirectButton" href="/about-me">{t("contactTitle")}</a></h2>
        <p>{t("contactText")}</p>
        <a href="mailto:fn-studio@outlook.com" className="btn primary">
          fn-studio@outlook.com
        </a>
      </section>

      {/* Footer */}
      <footer className="footer">
        © {new Date().getFullYear()} fn-studios. {t("footer")}
      </footer>
    </div>
  );
}
